import { createTheme } from '@mui/material/styles';
import { themeOptions } from 'theme';

/**
 * Mobile theme.
 *
 * Per the agreed architecture we REUSE the desktop design tokens
 * (palette + typography + spacing from `src/theme.js`) so the mobile app
 * stays on-brand, but we own the LAYOUT: mobile-tuned component defaults
 * live here and nowhere else.
 *
 * This is the only theme the mobile subtree ever sees — the mobile router
 * wraps everything in <ThemeProvider theme={mobileTheme}>.
 */
const mobileTheme = createTheme({
  ...themeOptions,
  components: {
    // Comfortable tap targets + no accidental horizontal scroll on phones.
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 8, textTransform: 'none', minHeight: 44 },
      },
    },
    MuiIconButton: {
      styleOverrides: { root: { padding: 8 } },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 8 } },
    },
  },
});

export default mobileTheme;
